import React from 'react';
import PropTypes from 'prop-types';

import {Chip, Divider, Stack, Box, TextField, Button, Typography} from '@mui/material';
import {translate} from 'views/module';

import {ExpandMore} from '@mui/icons-material';

import FilterMenuPopover from './FilterMenuPopover';
import FilterOptions from './FilterOptions';

const FilterChip = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchText, setSearchText] = React.useState('');

  const {
    filter,
    filterSelected,
    onClick,
    onDelete,
  } = props;

  const canBeEmpty = filter.canBeEmpty;
  const multiSelect = filter.multiSelect;

  React.useEffect(() => {
    if (anchorEl && filter.type === 'text') {
      setSearchText(filterSelected.label || '');
    }
  }, [anchorEl, filter, filterSelected]);

  const handleClick = (filter, item) => {
    onClick(filter, item);
    setAnchorEl(null);
  };

  let label = '';
  if (multiSelect) {
    label = filterSelected.map((e) => e.label).join(', ');
  } else {
    label = filterSelected.label;
  }

  return (
    <>
      <Chip
        label={
          <Stack
            direction={'row'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            {label}
            <ExpandMore />
            {
              !canBeEmpty &&
              <Divider orientation="vertical" variant="middle" flexItem sx={{pl: 1, my: 0.5}} />
            }
          </Stack>
        }
        onClick={(e) => setAnchorEl(e.currentTarget)}
        onDelete={canBeEmpty ? null : onDelete}
      />
      {
        anchorEl &&
        <FilterMenuPopover
          anchorEl={anchorEl}
          anchorPositionTop={anchorEl.getBoundingClientRect().bottom + 12}
          anchorPositionLeft={anchorEl.getBoundingClientRect().left}
          onClose={() => setAnchorEl(null)}
          display={
            filter.type === 'text' ?
            <Box sx={{p: 1}}>
              <Typography variant="subtitle2" sx={{mb: 1, fontWeight: 'bold'}}>
                {filter.label}
              </Typography>
              <Stack
                component="form"
                direction="row"
                spacing={1}
                onSubmit={() => {
                  handleClick(filter, {key: searchText, label: searchText});
                }}
              >
                <TextField
                  autoFocus
                  size="small"
                  placeholder={translate('caregiver.CaregiverList.Filter.CaregiverName')}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => e.stopPropagation()}
                />
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!searchText}
                >
                  {translate('caregiver.CaregiverList.Update')}
                </Button>
              </Stack>
            </Box> :
            <FilterOptions
              filter={filter}
              onClick={handleClick}
            />
          }
        />
      }
    </>
  );
};

FilterChip.propTypes = {
  filter: PropTypes.object.isRequired,
  filterSelected: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default React.memo(FilterChip);
